module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14gCHoL/tc-custom/9781460316702.jpg?1716663322121",
      "alt": "This image is the cover for the book Rings That Bind"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Rings That Bind\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Russian tycoon must devise a way to keep his wife from leaving their marriage of convenience in this contemporary romance.")]), _c('br'), _c('br'), _c('i', [_vm._v("On his terms only")]), _vm._v(" . . . "), _c('br'), _c('br'), _vm._v("The day Rosa agreed to wear Nicolai Baranski’s ring she wasn’t so foolish as to expect love. Yet nothing could have prepared her for the aching loneliness of her husband’s constant indifference—an indifference that proved too much to bear."), _c('br'), _c('br'), _vm._v("Nico is furious—no one turns their back on a Baranski. Rosa has some nerve if she thinks he will just let her walk away. He’ll use every sensual trick at his disposal to bring her back, begging for more. And once he’s got her where he wants her? He’ll let her go. But only when he’s ready!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michelle Smart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michelle Smart is a Publishers Weekly bestselling author with a slight-to-severe coffee addiction. A book worm since birth, Michelle can usually be found hiding behind a paperback, or if it’s an author she really loves, a hardback.  Michelle lives in rural Northamptonshire in England with her husband and two young Smarties. When not reading or pretending to do the housework she loves nothing more than creating worlds of her own. Preferably with lots of coffee on tap.  www.michelle-smart.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0